/**
 * Informações legais e de contato da empresa.
 * Fonte única de verdade — usada em Footer, About, páginas de política.
 * Para alterar CNPJ/razão social, edite apenas este arquivo.
 */
export const BUSINESS = {
  name:          'Menina Dourada',
  tradeName:     'Menina Dourada Swim',
  legalName:     'Menina Dourada Comércio de Moda Ltda',
  cnpj:          '55.850.673/0001-22',
  location:      'Rio de Janeiro – RJ',
  email:         'contato@meninadourada.shop',
  phone:         '(21) 97313-7347',
  whatsapp:      'https://wa.me/5521973137347',
  instagram:     'https://www.instagram.com/meninadouradaloja/',
  site:          'https://meninadourada.shop',
  supportHours:  'Segunda a Sexta: 9h às 18h',
  freeShipping:  250,          // R$ — valor único para frete grátis
  returnDays:    7,            // dias para devolução (CDC)
  exchangeDays:  30,           // dias para troca
};
